export default class MonitoringReportTripGenerationViewModel {
    startEnd: string = "0";
    start: string = "0";
    end: string = "0";
    mode: string = "0";
    direction: string = "0";
    tripRateParam: string = "0";
    enabled: boolean = false;
}